module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnUlEQVRoge3ZsRWCQBBF0a91UOx2Yx02gxE1QIKGuLPO8hHePYcMhnkBmyABwFkUSXPlVSwbbiiqXz414ha4d854YUDVbvfeW/RGAK4ucgq99T6NQjv9/TdAgBsBbgS4EeBGgBsBbgS4EeBGgBsBbgS4tQS80rf4YXZLwLPhmSPM/hgkTYr/0Ph2TevsXQySHpLGhMXHddZuywNAngUdoUa11PODUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_delete.png
// module id = TS8V
// module chunks = 1